import { Grid, Stack, Typography, Card, Box, Divider, Avatar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { AppColors } from '../../../Utils/helper/AppColors';
import { useSelector } from 'react-redux';
import CultService from '../../../Services/CultService';
import toast from 'react-hot-toast';
import PageLoader from '../../../Components/PageLoader';
import PageHeading from '../../../Components/PageHeading';
import UserThumbnail from '../../../Components/User/UserThumbnail';
import { ExpandIcon, UserIcon } from '../../../Components/Icons/Icons';
import moment from 'moment';
import userIcon from '../../../Assets/Icons/userIcon.svg';
import CustomTag from '../../../Components/CustomTag';
import CustomInfoTooltip from '../../../Components/CustomInfoTooltip';
import { theme } from 'antd';
import { getColorSettings } from '../../../Utils/helper/commonUtils';
import DataNotFound from '../../../Components/DataNotFound';
import { InsightsTable } from '../../Reporting/Components/InsightsTable';
import { HelperTexts } from '../../../Utils/helper/HelperTexts';
export default function KeyIssues({ campaignId , viewType }) {
	console.log("hi :", viewType);
	const [loading, setLoading] = useState(false);
	const company = useSelector((state) => state?.app?.company);
	const [subTopics, setSubTopics] = useState([]); // Array of subTopics
	const [selectedSubTopic, setSelectedSubTopic] = useState(null); // State to track selected subTopic
	const [isOverflow, setIsOverflow] = useState(false);

	const [shortDetails, setShortDetails] = useState([]);

	console.log('sel', selectedSubTopic);

	const localSettingColors = getColorSettings();

	const getDetails = async () => {
		setLoading(true);
		try {
			let res = await CultService.getIssuesV2({ params: { companyId: company?._id , campaignId : campaignId } });
			const rawDetails = res?.data?.data;

			// Flatten the data to create an array of subTopics
			const processedSubTopics = rawDetails?.flatMap((issue) =>
				issue?.subTopic?.map((subTopic) => ({
					...subTopic,
					issueName: issue.name, // Include the parent issue name for context
				})),
			);

			setSubTopics(processedSubTopics || []);
		} catch (err) {
			toast.error('Something went wrong');
		} finally {
			setLoading(false);
		}
	};

		const getShortDetails = async () => {
				setLoading(true);
				try {
					let res = await CultService.getShortCampaignDetails({ params: { campaignId : campaignId} });
					console.log('Short Details:', res);
					setShortDetails(res?.data?.data?.top10Issues);
				} catch (err) {
					toast.error(HelperTexts?.SOMETHING_WENT_WRONG);
				} finally {
					setLoading(false);
				}
			};
	

	useEffect(() => {
		if(company && campaignId) { getDetails(); getShortDetails(); }
	}, [company , campaignId]);

	useEffect(() => {
		if (subTopics?.length > 0) {
			setSelectedSubTopic(subTopics[0]); // Set the first subTopic as selected by default
		}
	}, [subTopics]);

	return (
		<Stack>
			{loading && <PageLoader />}

			{subTopics?.length === 0 && campaignId ?  (
				<Stack sx={{ height: 'calc(100vh - 170px)', backgroundColor: AppColors.WHITE, borderRadius: '10px' }}>
						<DataNotFound />
				</Stack>
			)
			 :
			 (
				viewType === 0 ? (

			<Grid container spacing={1} mt={2} height={'calc(100vh - 160px)'}>
				{/* Left Side: List of SubTopics */}
				<Grid
					item
					xs={12}
					sm={12}
					md={3.5}
					sx={{
						height: '100%',
						overflowY: 'auto',
					}}
				>
					<Stack gap={1}>
						{subTopics?.map((subTopic, index) => (
							<Stack
								key={index}
								direction="column"
								justifyContent="space-between"
								alignItems="flex-start"
								py={1}
								px={2}
								gap={1}
								height={'80px'}
								sx={theme => ({
									backgroundColor: selectedSubTopic?.name === subTopic.name ? theme.palette.primary.lightest_shade : AppColors.WHITE,
									borderRadius: 2,
									border: `1px solid ${theme.palette.primary.lighter_shade}`,
									cursor: 'pointer',
									width: '100%',
									'&:hover': { backgroundColor: theme.palette.primary.lightest_shade },
								})}
								onClick={() => setSelectedSubTopic(subTopic)} // Set selected subTopic
							>
								{/* SubTopic Name */}
								<Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }}>
									<Stack direction="row" alignItems="center" gap={1} sx={{ maxWidth: '300px', minWidth: '200px' }}>
										<Typography
											textTransform="capitalize"
											sx={(theme) => ({
												color: selectedSubTopic?.name === subTopic.name ? theme.palette.primary.darker_primary : AppColors.BLACK,
												fontSize: 14,
												fontWeight: 600,
												lineHeight: '150%',
												fontFamily: 'Poppins',
												textOverflow: 'ellipsis', // <-- add this

												overflow: 'hidden',
												whiteSpace: 'nowrap',
											})}
										>
											{subTopic.name}
										</Typography>

										{/* {isOverflow && <CustomInfoTooltip title={displayName} iconSize={18} placement="right" />} */}
									</Stack>

									<ExpandIcon color={localSettingColors.fontColor} size={16.34} />
								</Stack>
								{/* Report Tag */}
								<Stack
									direction="row"
									alignItems="center"
									justifyContent="center"
									sx={theme => ({
										backgroundColor: selectedSubTopic?.name === subTopic.name ? AppColors.WHITE : theme.palette.primary.lightest_shade,
										color: selectedSubTopic?.name === subTopic.name ? theme.palette.primary.lightest_shade : theme.palette.primary.darker_primary,
										borderRadius: '30px',
										display: 'inline-flex',
										justifyContent: 'center',
										alignItems: 'center',
										border: `1px solid ${theme.palette.primary.lighter_shade}`,
										px: 2,
										py: '6px',
									})}
								>
									<Typography
										sx={(theme) => ({
											fontSize: 12,
											fontWeight: 500,
											fontFamily: 'Poppins',
											lineHeight: '121%',
											color: theme.palette.primary.darker_primary,
										})}
									>
										Reported: {subTopic.cluster?.reduce((total, clusterItem) => total + (clusterItem?.unique_users || 0), 0)}
									</Typography>
								</Stack>

								{/* <CustomTag tagTitle={`Reported: ${subTopic.cluster?.reduce((total, clusterItem) => total + (clusterItem?.unique_users || 0), 0)}`} height={24} fontSize={10} fontWeight={400} lineHeight={'121%'} /> */}
							</Stack>
						))}
					</Stack>
				</Grid>

				{/* Right Side: Details of Selected SubTopic */}
				<Grid item xs={12} md={8.5}>
					{selectedSubTopic ? (
						<Box
							sx={theme => ({
								backgroundColor: AppColors.WHITE,
								borderRadius: '15px',
								border: `1px solid ${theme.palette.primary.lightest_shade}`,
								p: 2,
								boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
								height: '100%',
								overflowY: 'auto',
							})}
						>
							<Stack gap={2}>
								{/* SubTopic Details */}
								<Stack direction="row" justifyContent="space-between" alignItems="center">
									<Typography
										textTransform="capitalize"
										sx={{
											color: AppColors.HEADING_TITLE,
											fontSize: 18,
											fontWeight: 600,
											lineHeight: '150%',
											fontFamily: 'Poppins',
										}}
									>
										{selectedSubTopic?.name}
									</Typography>

									<CustomTag
										tagTitle={`Reported: ${selectedSubTopic.cluster?.reduce(
											(total, clusterItem) => total + (clusterItem?.unique_users || 0),
											0,
										)}`}
										pX={'16px'}
										pY={'6px'}
										fontSize={12}
										fontWeight={500}
										lineHeight={'121%'}
									/>
								</Stack>

								<Divider sx={{ my: 1 }} />

								{/* Clusters in the SubTopic */}
								{selectedSubTopic?.cluster?.map((cluster, clusterIndex) => (
									<Stack key={clusterIndex} gap={2}>
										{/* Users in the Cluster */}
										{cluster?.users?.map((user, userIndex) => (
											<Stack key={userIndex} direction="column" alignItems="start" gap={'8px'}>
												{/* User Thumbnail */}
												<Stack direction="row" alignItems="center" gap={1}>
													{/* <Avatar src={userIcon} sx={{ height: 30, width: 30 }} /> */}
													<Box sx={theme => ({ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30 , borderRadius: '50%', border:`1px solid ${theme.palette.primary.primary_shade}`  ,backgroundColor: theme.palette.primary.lightest_shade })}>
														<UserIcon size={20} color={localSettingColors.buttonBackground} />
													</Box>
													<Stack direction="column" alignItems="start" gap={'4px'}>
														<UserThumbnail
															user={user?.mentionData?.anonymous ? null : user?.userId}
															userId={user?.mentionData?.anonymous ? null : user?.userId?._id}
															textFontSize={'14px'}
														/>
														<Typography
															fontFamily={'Poppins'}
															fontWeight={500}
															fontSize={12}
															lineHeight={'121%'}
															color={AppColors.HEADING_TITLE4}
														>
															{' '}
															{moment(user?.mentionData?.timestamp).format('MM/DD/YYYY hh:mm A')}
														</Typography>
													</Stack>
												</Stack>

												{/* <Stack>
													<Typography
														fontFamily={'Poppins'}
														fontWeight={700}
														fontSize={14}
														lineHeight={'150%'}
														color={AppColors.HEADING_TITLE4}
													>
														Campaign: Not Available
													</Typography>
												</Stack> */}
												<Typography
													fontFamily={'Poppins'}
													fontWeight={400}
													fontSize={14}
													lineHeight={'150%'}
													color={AppColors.HEADING_TITLE4}
												>
													{user.mentionData?.text}
												</Typography>
											</Stack>
										))}
									</Stack>
								))}
							</Stack>
						</Box>
					) : (
						<Stack alignItems="center" justifyContent="center" height="100%">
							<Typography variant="h6" color={AppColors.TEXT_SECONDARY}>
								{/* Select a subtopic to view details */}
							</Typography>
						</Stack>
					)}
				</Grid>
			</Grid> ) :  (
								<InsightsTable
									data={shortDetails} issues={true}
								/>
							)

			)}
		</Stack>
	);
}
